import axios from "axios";
// import QS from 'qs';  //序列化请求
import methodsToken from "./api.js";
import storage from "../utils/storage";
import routerIndex from "../router";
import { apiBaseUrl } from "./env";
import { Message } from "element-ui";
axios.defaults.baseURL = apiBaseUrl;

//配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
export function get(url, params = {}) {
  if (!params.token) {
    let userToken = storage.get("userToken");
    if (userToken) {
      params.token = userToken;
    }
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export function post(method, params = {}) {
  if (methodsToken.indexOf(method) >= 0) {
    let userToken = storage.get("userToken");
    if (!userToken || userToken == "") {
      routerIndex.push("/login");
    } else {
      params.token = userToken;
    }
  }
  if (!params.token) {
    let userToken = storage.get("userToken");
    if (userToken) {
      params.token = userToken;
    }
  }
  params.method = method;
  return new Promise((resolve, reject) => {
    if (!params.token) {
      let userToken = storage.get("userToken");
      if (userToken) {
        params.token = userToken;
      }
    }
    axios
      .post("api.html", params)
      .then((res) => {
        const result = res.data;
        if (!result.status) {
          // 登录信息过期或者未登录
          // Message({
          //   showClose: true,
          //   message: result.msg,
          //   type: 'error',
          //   duration: 1500
          // })
          if (result.data === 14007 || result.data === 14006) {
            storage.remove("userToken");
			
			let url = window.location.href;
			url = url.toLowerCase();
			if (url.indexOf('/web/login') <= -1 && url.indexOf('/web/author') <= -1) {
				routerIndex.push("/login");
			}
          }
        }
        resolve(result);
      })
      .catch((err) => {
        if (err && err.response) {
          Message({
            showClose: true,
            // message: err.response,
            message: '错误信息：'+err.response.statusText+'，请联系应用管理员',
            type: "error",
            duration: 1500,
          });
          // reject(err.response)
        }
      });
  });
}
//上传文件
export const uploadImage = (url, data) => {
  if (!data.token) {
    let userToken = storage.get("userToken");
    if (userToken) {
      data.append("token", userToken);
    }
  }
  return new Promise((resolve, reject) => {
    data.append("method", "images.upload");
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
};
// 获取商品分类

//顶部底部导航
export const shopMenu = (p) =>
  get(apiBaseUrl + "/plugins/pc-api-getMenu.html", p);
//首页楼层
export const homeLoftData = (p) =>
  get(apiBaseUrl + "/plugins/pc-api-getFloor.html", p);
// 获取店铺配置
// export const shopConfig = p => get(apiBaseUrl + '/api/common/jshopconf', p);

// 获取店铺配置
export const shopConfig = (p) => post("common.jshopconf", p);

// 用户注册
export const reg = (p) => post("user.reg", p);

// 用户登录
export const login = (p) => post("user.login", p);

// 用户信息
export const userInfo = (p) => post("user.info", p);

// 上传头像
export const changeAvatar = (p) => post("user.changeavatar", p);

// 编辑用户信息
export const editInfo = (p) => post("user.editinfo", p);

// 发送短信验证码
export const sms = (p) => post("user.sms", p);

// 短信验证码登录
export const smsLogin = (p) => post("user.smslogin", p);

// 退出登录
export const logout = (p) => post("user.logout", p);

// 获取首页幻灯片
export const slider = (p) => post("advert.getAdvertList", p);

// 获取公告列表
export const notice = (p) => post("notice.noticeList", p);

// 获取公告详情
export const noticeInfo = (p) => post("notice.noticeInfo", p);

// 获取文章详情
export const articleInfo = (p) => post("articles.getArticleDetail", p);

// 获取文章列表
export const articleList = (p) => post("articles.getArticleList", p);
//获取文章分类列表
export const articleTypeList = (p) => post("articles.getArticleType", p);
//获取文章推荐
export const articleRecommend = (p) => post("articles.leftarticletype", p);

// 获取商品分类
export const categories = (p) => post("categories.getallcat", p);

// 获取商品列表
export const goodsList = (p) => post("goods.getlist", p);

// 获取商品详情
export const goodsDetail = (p) => post("goods.getdetial", p);

// 获取商品参数信息
export const goodsParams = (p) => post("goods.getgoodsparams", p);

// 获取设置默认货品
export const getProductInfo = (p) => post("goods.getproductinfo", p);

// 获取商品评论信息
export const goodsComment = (p) => post("goods.getgoodscomment", p);

// 添加购物车
export const addCart = (p) => post("cart.add", p);

// 移除购物车
export const removeCart = (p) => post("cart.del", p);

// 获取购物车列表
export const cartList = (p) => post("cart.getlist", p);

// 设置购物车商品数量
export const setCartNum = (p) => post("cart.setnums", p);

// 获取购物车数量
export const getCartNum = (p) => post("cart.getnumber", p);

// 获取用户的收货地址列表
export const userShip = (p) => post("user.getusership", p);

// 获取用户默认收货地址
export const userDefaultShip = (p) => post("user.getuserdefaultship", p);

// 存储用户收货地址
export const saveUserShip = (p) => post("user.vuesaveusership", p);

// 获取收货地址详情
export const shipDetail = (p) => post("user.getshipdetail", p);

// 收货地址编辑
export const editShip = (p) => post("user.editship", p);

// 收货地址删除
export const removeShip = (p) => post("user.removeship", p);

// 设置默认收货地址
export const setDefShip = (p) => post("user.setdefship", p);

// 获取发票列表
export const myinvoIcelist = (p) => post("user.myinvoicelist", p);

// 生成订单
export const createOrder = (p) => post("order.create", p);

// 获取状态订单列表
export const getOrderList = (p) => post("order.getlist", p);

// 取消订单
export const cancelOrder = (p) => post("order.cancel", p);

// 删除订单
export const delOrder = (p) => post("order.del", p);

// 获取订单详情
export const orderDetail = (p) => post("order.details", p);

// 确认收货
export const confirmOrder = (p) => post("order.confirm", p);

// 获取配送方式
export const orderShip = (p) => post("order.getship", p);

// 获取全部订单列表
export const orderList = (p) => post("order.getorderlist", p);

// 获取订单不同状态的数量
export const getOrderStatusSum = (p) => post("order.getorderstatusnum", p);

// 售后单列表
export const afterSalesList = (p) => post("order.aftersaleslist", p);

// 售后单详情
export const afterSalesInfo = (p) => post("order.aftersalesinfo", p);

// 订单售后状态
export const afterSalesStatus = (p) => post("order.aftersalesstatus", p);

// 添加售后单
export const addAfterSales = (p) => post("order.addaftersales", p);

// 用户发送退货包裹
export const sendShip = (p) => post("order.sendreship", p);

// 添加商品浏览足迹
export const addGoodsBrowsing = (p) => post("user.addgoodsbrowsing", p);

// 删除商品浏览足迹
export const delGoodsBrowsing = (p) => post("user.delgoodsbrowsing", p);

// 获取商品浏览足迹
export const goodsBrowsing = (p) => post("user.goodsbrowsing", p);

// 商品收藏 关注/取消
export const goodsCollection = (p) => post("user.goodscollection", p);

// 获取商品收藏关注列表
export const goodsCollectionList = (p) => post("user.goodscollectionlist", p);

// 获取店铺支付方式列表
export const paymentList = (p) => post("payments.getlist", p);

// 支付确认页校验（单笔/合并）
export const paymentsCheckpay = (p) => post("payments.checkpay", p);

// 获取支付单详情
export const paymentInfo = (p) => post("payments.getinfo", p);

// 支付接口
export const pay = (p) => post("user.pay", p);

// 订单评价接口
export const orderEvaluate = (p) => post("user.orderevaluate", p);

// 判断是否签到
export const isSign = (p) => post("user.issign", p);

// 签到接口
export const sign = (p) => post("user.sign", p);

// 我的积分
export const myPoint = (p) => post("user.mypoint", p);

// 积分记录
export const pointLog = (p) => post("user.userpointlog", p);

// 物流信息接口
export const logistics = (p) => post("order.logisticbyapi", p);

// 优惠券列表
export const couponList = (p) => post("coupon.couponlist", p);

// 优惠券详情
export const couponDetail = (p) => post("coupon.coupondetail", p);

// 用户领取优惠券
export const getCoupon = (p) => post("coupon.getcoupon", p);

// 用户已领取的优惠券列表
export const userCoupon = (p) => post("coupon.usercoupon", p);

// 获取店铺设置
export const getSetting = (p) => post("user.getsetting", p);

// 获取商户配置信息
export const getSellerSetting = (p) => post("user.getsellersetting", p);

// 获取我的银行卡列表
export const getBankCardList = (p) => post("user.getbankcardlist", p);

// 获取默认的银行卡
export const getDefaultBankCard = (p) => post("user.getdefaultbankcard", p);

// 添加银行卡
export const addBankCard = (p) => post("user.addbankcard", p);

// 删除银行卡
export const removeBankCard = (p) => post("user.removebankcard", p);

// 设置默认银行卡
export const setDefaultBankCard = (p) => post("user.setdefaultbankcard", p);

// 获取银行卡信息
export const getBankCardInfo = (p) => post("user.getbankcardinfo", p);

// 获取银行卡组织信息
export const getBankCardOrganization = (p) =>
  post("user.getbankcardorganization", p);

// 用户修改密码
export const editPwd = (p) => post("user.editpwd", p);

// 用户找回密码
export const forgotPwd = (p) => post("user.forgetpwd", p);

// 获取用户余额明细
export const getBalanceList = (p) => post("user.balancelist", p);

// 用户推荐列表
export const recommendList = (p) => post("user.recommend", p);

// 邀请码
export const shareCode = (p) => post("user.sharecode", p);

// 用户提现
export const userToCash = (p) => post("user.cash", p);

// 用户提现列表
export const cashList = (p) => post("user.cashlist", p);

// 获取授权登录方式
export const getTrustLogin = (p) => post("user.gettrustlogin", p);

// 绑定授权登录
export const trustBind = (p) => post("user.trustbind", p);

// 获取用户信息
export const trustLogin = (p) => post("user.trustcallback", p);

// 判断用户下单可以使用多少积分
export const usablePoint = (p) => post("user.getuserpoint", p);

// 门店列表
export const storeList = (p) => post("store.getstorelist", p);

// 判断是否开启门店自提
export const switchStore = (p) => post("store.getstoreswitch", p);

// 获取默认的门店
export const defaultStore = (p) => post("store.getdefaultstore", p);

// 判断是否开启积分
export const isPoint = (p) => post("user.ispoint", p);

// 用户输入code领取优惠券
export const couponKey = (p) => post("coupon.getcouponkey", p);

// 判断是否是店员
export const isStoreUser = (p) => post("store.isclerk", p);

// 获取店铺提货单列表
export const storeLadingList = (p) => post("store.storeladinglist", p);

// 获取提货单详情
export const ladingInfo = (p) => post("store.ladinginfo", p);

// 店铺提单操作
export const ladingExec = (p) => post("store.lading", p);

// 提货单删除
export const ladingDel = (p) => post("store.ladingdel", p);

// 获取活动列表
export const activityList = (p) => post("group.getlist", p);

// 获取活动详情
export const activityDetail = (p) => post("group.getgoodsdetial", p);
//取搜索页推荐关键字
export const getRecommendKeys = (p) => post("store.getrecommendkeys", p);
//取下级地址列表
export const getAreaList = (p) => post("user.getarealist", p);
//推荐更多商品
export const getPickGoods = (p) => post("goods.getpickgoods", p);

// 获取默认选中购物车列表全部信息
export const cartListSelectAll = (p) => post("cart.getlistselectall", p);

// 获取销售排行榜
export const getSalesRanking = (p) => post("goods.salesRanking", p);

// 拍卖详情
export const auctionDetails = (p) => post("api.details.auction", p);

//拍卖明细
export const auctionInfo = (p) => post("api.details.auction", p);

//报名
export const auctionEnroll = (p) => post("api.enroll.auction", p);

//报名详情
export const getEnrollInfo = (p) => post('api.getenrollinfo.auction', p);

//出价
export const auctionOffer = (p) => post("api.offer.auction", p);

// 自动出价设置保存
export const autoOfferSave = (p) => post("api.autoset.auction", p);

// 自动出价设置查询
export const autoOfferInfo = (p) => post("api.autoget.auction", p);

//大象SSO登录
export const getDaxiang = (p) => post("user.daxianglogin", p);

//拍卖列表
export const auctionList = (p) => post("api.list.auction", p);

// 低价专区列表
export const lowpriceList = (p) => post("api.lowpricelist.auction", p);

// 我关注的拍卖（收藏或出价过，仅开启）
export const myFollowAuctions = (p) => post("api.myfollowauctions.auction", p);

//定时循环获取数据
export const auctionGetLastlog = (p) => post("api.getlastlog.auction", p);

//报名列表
export const enrollList = (p) => post("api.enrolllist.auction", p);

// 数据统计接口 
export const addRecord = (p) => post("api.addrecord.statistics", p);



// 评论列表
export const listtopic = (p) => post("api.list.topic", p);

// 添加评论
export const addtopic = (p) => post("api.add.topic", p);



// 评论点赞
export const liketopic = (p) => post("api.like.topic", p);


// 放弃购买
export const giveUpAuction = (p) => post("api.giveup.auction", p);

// 删除评论
export const delTopic = (p) => post("api.del.topic", p);


// 获取广告

export const advert = (p) => post("advert.getcarousellists", p);


// 出价记录分页
export const getofferlog = (p) => post("api.getofferlog.auction", p);


// 出价记录分页
export const getPointRanking = (p) => post("user.pointranking", p);



//报名
export const auctionNotice = (p) => post("api.notice.auction", p);
//统一分享
export const share = (p) => post("user.share", p);

export const getCarouselLists = (p) => post("advert.getcarousellists", p);


//取消超越提醒
export const cancleSurpassNotice = (p) => post("api.canclesurpassnotice.auction", p);

//关闭拍卖结束时间提醒（前端调用）
export const closeAuctionEndTimeRemind = (p) => post("api.closeauctionendtimeremind.auction", p);

// 邀请活动详情
export const getInviteActivityDetail = (p) => post("api.getdetail.InviteActivity", p);

// 邀请活动奖品列表
export const getInviteActivityGoodsList = (p) => post("api.getgoodslist.InviteActivity", p);

// 邀请活动兑换奖品
export const redeemInviteActivityPrize = (p) => post("api.redeemprize.InviteActivity", p);

// 邀请活动邀请记录
export const getInviteActivityInviteLog = (p) => post("api.myinvitelog.InviteActivity", p);

// 邀请活动兑换订单
export const getInviteActivityOrderList = (p) => post("api.myorderlist.InviteActivity", p);

// 邀请活动访问记录
export const recordInviteActivityVisit = (p) => post("api.recordvisit.InviteActivity", p);